module.exports = __webpack_public_path__ + "assets/cover_1_old.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/cover_1_old.jpg
 ** module id = 206
 ** module chunks = 1
 **/